import { render, staticRenderFns } from "./BRELAG_ShutterMoveJalousie.vue?vue&type=template&id=56a6e328&"
import script from "./BRELAG_ShutterMoveJalousie.vue?vue&type=script&lang=js&"
export * from "./BRELAG_ShutterMoveJalousie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports